import SmartLink from "@/components/marketing/smart-link";

function renderAction(action, index) {
  return (
    <SmartLink
      key={`${action.label}-${index}`}
      href={action.href}
      className={action.className || "btn btn-light"}
    >
      {action.icon ? <i className={`${action.icon} me-2`} aria-hidden="true" /> : null}
      <span>{action.label}</span>
    </SmartLink>
  );
}

export default function CtaBand({ id, eyebrow, title, copy, actions = [], children }) {
  return (
    <section id={id} className="public-section public-section--cta">
      <div className="public-container">
        {children}

        <div className="public-cta-band">
          <h2 className="public-cta-band__title">{title}</h2>
          <p className="public-cta-band__copy">{copy}</p>

          {actions.length > 0 ? (
            <div className="public-cta-band__actions">
              {actions.map(renderAction)}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
